export default __webpack_public_path__ + "static/media/pharmeasy.8081b308.png";